import { getEditorText } from './getEditorText';

export const isMaxEditorChars = (text: string, max: number): boolean => {
  const editorText = getEditorText(text);

  return editorText.length > max;
};
